import { dictionary } from "@/helpers";
import { tools } from "@/helpers";

const booking_excel_template = "glsexpressbookingtemplate.xlsx";

const customer_no_field_name = "customer_no";

const mandatoryFields = [
  "customer_no",
  "pickup_delivery_type",
  "name",
  "address_1",
  "zip",
  "country_code",
  "date",
  "from_time",
  "to_time",
  "goods_quantity",
  "goods_weight",
  "goods_description"
];

const optionalFields = [
  "contact_name",
  "contact_phone",
  "goods_unit_type",
  "goods_reference"
];

function validateBookingExcel(excelJSON, validAccounts) {
  let errors = [];

  // validate fields
  let invalidKeys = [];

  excelJSON.forEach(row => {
    if (row) {
      const keys = Object.keys(row);
      keys.forEach(key => {
        if (
          !key ||
          (!mandatoryFields.includes(key) &&
            !optionalFields.includes(key) &&
            !invalidKeys.includes(key))
        ) {
          invalidKeys.push(key);
        }
      });
    }
  });

  invalidKeys.forEach(invalidKey => {
    if (invalidKey) {
      errors.push(dictionary.errors.excel.field.not_valid + ": " + invalidKey);
    }
  });

  // validate content
  let missingValues = [];
  let invalidCustomerNos = [];

  excelJSON.forEach(row => {
    if (row) {
      mandatoryFields.forEach(mandatoryField => {
        const value = row[mandatoryField];
        if (!value && !missingValues.includes(mandatoryField)) {
          missingValues.push(mandatoryField);
        } else if (mandatoryField == customer_no_field_name && validAccounts) {
          let customerIdValid = false;
          validAccounts.forEach(account => {
            if (account && account.id == value) {
              customerIdValid = true;
            }
          });
          if (!customerIdValid && !invalidCustomerNos.includes(value)) {
            invalidCustomerNos.push(value);
          }
        }
      });
    }
  });

  missingValues.forEach(missingValue => {
    if (missingValue) {
      errors.push(dictionary.errors.excel.field.missing + ": " + missingValue);
    }
  });

  invalidCustomerNos.forEach(invalidCustomerNo => {
    if (invalidCustomerNo) {
      errors.push(
        customer_no_field_name +
          " " +
          dictionary.errors.excel.value.not_valid +
          ": " +
          invalidCustomerNo
      );
    }
  });

  return errors;
}

function parseOrders(excelJSON) {
  let orders = [];
  excelJSON.forEach(row => {
    if (row) {
      orders.push({
        order: {
          externalreference: row.customer_no + "_" + new Date().getTime(),
          type:
            row.pickup_delivery_type ==
            dictionary.constants.address_types.pickup
              ? 1
              : 2,
          customerno: row.customer_no,
          address: {
            name1: row.name,
            address1: row.address_1,
            zip: row.zip,
            city: "",
            countrycode: row.country_code
          },
          instructions: row.address_2 ? row.address_2 : "",
          fromtime: parseDateTime(row.date, row.from_time),
          totime: parseDateTime(row.date, row.to_time),
          contactname: row.contact_name ? row.contact_name : "",
          contactphone: row.contact_phone ? row.contact_phone : "",
          cll: tools.parseDouble(row.goods_quantity),
          unittype: row.goods_unit_type ? row.goods_unit_type : "",
          grossweight: tools.parseDouble(row.goods_weight),
          freightweight: tools.parseDouble(row.goods_weight),
          description: row.goods_description,
          reference: row.goods_reference ? row.goods_reference : ""
        }
      });
    }
  });

  return orders;
}

function parseDateTime(date, time) {
  var utc_days = Math.floor(date - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);

  date_info.setHours(0, 0, 0, 0);
  date_info.setMinutes(time * 24 * 60);

  let dateTime =
    tools.splitDateTime(date_info).date +
    "T" +
    tools.splitDateTime(date_info).time +
    ".00:000";

  return dateTime;
}

// function ExcelDateToJSDate(serial) {
//   var utc_days = Math.floor(serial - 25569);
//   var utc_value = utc_days * 86400;
//   var date_info = new Date(utc_value * 1000);

//   var fractional_day = serial - Math.floor(serial) + 0.0000001;

//   var total_seconds = Math.floor(86400 * fractional_day);

//   var seconds = total_seconds % 60;

//   total_seconds -= seconds;

//   var hours = Math.floor(total_seconds / (60 * 60));
//   var minutes = Math.floor(total_seconds / 60) % 60;

//   return new Date(
//     date_info.getFullYear(),
//     date_info.getMonth(),
//     date_info.getDate(),
//     hours,
//     minutes,
//     seconds
//   );
// }

export const excelTools = {
  booking_excel_template,
  validateBookingExcel,
  parseOrders
};
